import { type ReactElement } from 'react'
import * as S from './about-card.styled'
import { type AboutCardProps } from './about-card.props'

export function AboutCard ({ text, className, image }: AboutCardProps): ReactElement {
  return <S.Container className={className}>
    <figure>
      <img src={image} alt="" />
    </figure>
    <div dangerouslySetInnerHTML={{ __html: text }} />
  </S.Container>
}
